"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return [["não apenas", "como também"], ["não só", "bem como"], ["não só", "como também"], ["não só", "mas também"], ["ora", "ora"], ["ou", "ou"], ["quer", "quer"]];
};